export const Stage = {
  production: 'production',
  staging: 'staging',
  development: 'development',
  localhost: 'localhost',
} as const;

export type Stage = (typeof Stage)[keyof typeof Stage];

export const validateStage = (stage: string): stage is Stage => {
  return Object.values(Stage).some(v => v === stage);
};
